import { Component, OnInit } from '@angular/core';

import * as moment from 'moment';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-profesionales-search',
  templateUrl: './profesionales-search.component.html',
  styleUrls: ['./profesionales-search.component.scss'],
  providers: [CommonService]
})
export class ProfesionalesSearchComponent implements OnInit {
  public profesionales:any[];
  public selectedProfesional:any;
  public turnos:any[];

  private counter:number;
  private dayCounter:number;

  public search:any;
  public selectedDate:Date;

  public day;
  public weekday;
  public month;
  public year;

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.selectedProfesional = 0;
    this.counter = 0;
    this.dayCounter = 0;
    this.selectedDate = new Date();

    this.commonService.getProfesionales()
      .then(result => this.profesionales = result);
  }

  getTurnosP() {
    let profesionalId = this.selectedProfesional.id;

    this.search = {
      dia: this.getDia(),
      profesional: this.selectedProfesional.id,
      fecha: this.selectedDate
    };

    this.listTurnosP(false);
  }

  listTurnosP(isPrev) {
    this.commonService.searchTurnosP(this.search).then(result => {
      this.counter++;

      if (result.length === 0 && this.counter < 8) {
        if (isPrev) {
          this.search.fecha = moment(this.search.fecha).subtract(1,'d').toDate();
        } else {
          this.search.fecha = moment(this.search.fecha).add(1,'d').toDate();
        }
        this.search.dia = moment(this.search.fecha).weekday();

        if (this.search.dia === 6) {
          this.search.fecha = moment(this.search.fecha).add(2,'d').toDate();
          this.search.dia = moment(this.search.fecha).weekday();
        }

        if (this.search.dia === 0 && isPrev) {
          this.search.fecha = moment(this.search.fecha).subtract(2,'d').toDate();
          this.search.dia = 5;
        }

        this.listTurnosP(isPrev);
      } else {
        this.turnos = result;
        this.composeFechas();
      }
    });
  }

  searchNext():void {
    let newDate = moment(this.search.fecha).add(1, 'd');
    this.search.fecha = newDate.toDate();
    this.search.dia = newDate.weekday(); 

    this.dayCounter++;
    this.counter = 0;
    this.turnos = [];
    this.listTurnosP(false);
  }

  searchPrev():void {
    let newDate = moment(this.search.fecha).subtract(1, 'd');
    this.search.fecha = newDate.toDate();
    this.search.dia = newDate.weekday(); 

    if (this.search.dia === 0) {
      this.search.fecha = moment(this.search.fecha).subtract(2,'d').toDate();
      this.search.dia = 5;
    }

    this.dayCounter--;
    this.counter = 0;
    this.turnos = [];
    this.listTurnosP(true);
  }

  private composeFechas():void {
    let dias = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
      meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

    this.day = this.search.fecha.getDate();
    this.weekday = dias[this.search.fecha.getDay()];
    this.month = meses[this.search.fecha.getMonth()];
    this.year = this.search.fecha.getFullYear();
  }

  private getDia() {
    let dia;

    if(!this.selectedDate) {
      this.selectedDate = moment().add(2, 'd').toDate();
    }

    dia = moment(this.selectedDate).weekday();

    if (dia === 6) {
      this.selectedDate = moment(this.selectedDate).add(2,'d').toDate();
      dia = 1;
    }

    if (dia === 0) {
      this.selectedDate = moment(this.selectedDate).add(1,'d').toDate();
      dia = 1;
    }

    return dia;
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/home/profesionales-search/profesionales-search.component.ts